<span class="badge badge--{{ color }}"
      [ngClass]="{
        'badge--has-close': closable
      }">

  <ng-content></ng-content>

  <app-icon [name]="ICONS.CLOSE" *ngIf="closable" class="badge__close-icon" (click)="onCloseClick($event)"></app-icon>
</span>
